/**
 * 公開ページ (`/public/*`, `/l/*`, `/liff/*`) のための body 制約解除フック。
 *
 * admin-web の globals.css は AppLayout 内部スクロール用に
 *   body { overflow: hidden; height: 100vh }
 *   #root { height: 100vh }
 * を設定しているため、AppLayout 外の長尺ページは body 自体がスクロール不可になる。
 *
 * このフックは body に `.public-page-mode` クラスを付け、
 * globals.css 側で `!important` で overflow / height を上書きする。
 */
import { useEffect } from 'react';

export function usePublicPageMode(): void {
  useEffect(() => {
    document.body.classList.add('public-page-mode');
    return () => {
      document.body.classList.remove('public-page-mode');
    };
  }, []);
}
